import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PercentFormatter } from '../../../shared/helpers/percent-formatter.helper';
import { noneZeroValidator } from '../../../shared/validators/custom-validators.validator';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class AEtrTradeProvider {
  aEtrTradeForm: FormGroup;
  readonly #fb = inject(FormBuilder);

  initForm(data?: any): void {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);

    this.aEtrTradeForm = this.#fb.group({
      type: [data?.type || ''],
      ccy: [data?.ccy || '', [Validators.required]],
      issuedDate: [
        this.#toNgbDate(data?.issuedDate) || null,
        [Validators.required],
      ],
      deposit: [
        data?.deposit || data?.deposit === 0
          ? PercentFormatter(+data?.deposit * 100, false)
          : null,
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      faceValue: [
        data?.faceValue || '',
        [Validators.required, noneZeroValidator()],
      ],
      unitPrice: [
        data?.unitPrice || '',
        [Validators.required, noneZeroValidator()],
      ],
      months: [
        data?.months || '',
        [Validators.required, Validators.max(120), noneZeroValidator()],
      ],
      rejectedMessage: [data?.rejectedMessage || ''],
      creditorId: [
        { value: data?.creditorId || null, disabled: !!data?.acquisitionId },
        [Validators.required],
      ],
    });
  }

  #toNgbDate(dateString: string): NgbDateStruct | null {
    if (!dateString) return null;
    const [y, m, d] = dateString.split('-').map(Number);
    return { year: y, month: m, day: d };
  }
}
